import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

// Read side lives in straightener-common (shared with the recipe editor);
// this repository only owns the write.
export const upsertStraightenerParameterConfig = async (args: {
	code: string;
	min: number | null;
	max: number | null;
	sendToPlc: boolean | null;
	isRequired: boolean | null;
}): Promise<void> => {
	const api = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ParameterCode", value: args.code },
		{ name: "MinValue", value: args.min },
		{ name: "MaxValue", value: args.max },
		{ name: "SendToPlc", value: args.sendToPlc },
		{ name: "IsRequired", value: args.isRequired },
	];
	const resp = await api.callV2(
		"[MILL].[UpsertStraightenerParameterConfig]",
		parameters,
	);
	if (!resp.ok) {
		throw new Error(
			get(resp, "message", "") || "Error saving straightener parameter",
		);
	}
};
